var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00684 17.436C9.00684 17.9665 8.79612 18.4752 8.42105 18.8502C8.04598 19.2253 7.53727 19.436 7.00684 19.436C6.4764 19.436 5.9677 19.2253 5.59262 18.8502C5.21755 18.4752 5.00684 17.9665 5.00684 17.436C5.00684 16.9056 5.21755 16.3969 5.59262 16.0218C5.9677 15.6467 6.4764 15.436 7.00684 15.436C7.53727 15.436 8.04598 15.6467 8.42105 16.0218C8.79612 16.3969 9.00684 16.9056 9.00684 17.436ZM19.0068 17.436C19.0068 17.9665 18.7961 18.4752 18.421 18.8502C18.046 19.2253 17.5373 19.436 17.0068 19.436C16.4764 19.436 15.9677 19.2253 15.5926 18.8502C15.2176 18.4752 15.0068 17.9665 15.0068 17.436C15.0068 16.9056 15.2176 16.3969 15.5926 16.0218C15.9677 15.6467 16.4764 15.436 17.0068 15.436C17.5373 15.436 18.046 15.6467 18.421 16.0218C18.7961 16.3969 19.0068 16.9056 19.0068 17.436Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00684 10.436L18.0068 10.436M2.00684 10.436C2.00684 11.216 1.98684 13.476 2.01084 15.696C2.04684 16.416 2.16684 17.016 5.00884 17.436M2.00684 10.436C2.22284 8.69604 3.16184 6.63604 3.64184 5.85604M9.00684 10.436V5.43604M14.9968 17.436L9.00184 17.436M2.02184 5.43604L12.2398 5.43604C12.2398 5.43604 12.7798 5.43604 13.2598 5.48404C14.1588 5.56804 14.9138 5.97604 15.6698 6.99604C16.4698 8.07604 17.0838 9.44403 17.8998 10.176C19.2548 11.392 21.8328 11.016 21.9768 13.596C22.0128 14.916 22.0128 16.356 21.9528 16.596C21.8558 17.303 21.3108 17.418 20.6328 17.436C20.0448 17.452 19.3358 17.408 18.9908 17.436",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarsIcon);
export default __webpack_public_path__ + "static/media/cars-icon.4b872748db90520cd5a86e617b22d3fb.svg";
export { ForwardRef as ReactComponent };